// BackendHelper/endpoints.js
const API_ENDPOINTS = {
  // Authentication endpoints
  AUTH: {
    LOGIN: "/auth/login",
    LOGOUT: "/auth/logout",
    LOGOUT_ALL: "/auth/logout-all",
    REGISTER: "/auth/register",
    REFRESH_TOKEN: "/auth/refresh-token",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: "/auth/reset-password",
    CHANGE_PASSWORD: "/auth/change-password",
    PROFILE: "/auth/profile",
  },

  // User management endpoints
  USERS: {
    BASE: "/users",
    PROFILE: "/users/profile",
    UPDATE_PROFILE: "/users/profile",
    BY_ID: (id) => `/users/${id}`,
    CHANGE_PASSWORD: "/users/change-password",
    UPLOAD_AVATAR: "/users/avatar",
  },

  // Course endpoints
  COURSES: {
    BASE: "/courses",
    BY_ID: (id) => `/courses/${id}`,
    ENROLL: (id) => `/courses/${id}/enroll`,
    CONTENT: (id) => `/courses/${id}/content`,
    PROGRESS: (id) => `/courses/${id}/progress`,
    ASSESSMENTS: (id) => `/courses/${id}/assessments`,
    CERTIFICATES: (id) => `/courses/${id}/certificates`,
  },

  // Student endpoints
  STUDENTS: {
    BASE: "/student",
    BY_ID: (id) => `/student/${id}`,
    //COURSES: (id) => `/student/${id}/courses`,
    PROGRESS: (id) => `/student/${id}/progress`,
    ASSESSMENTS: (id) => `/student/${id}/assessments`,
    CERTIFICATES: {
    BASE: "/student/certificates",
    CHECK_AVAILABILITY: (courseId) => `/student/certificates/check/${courseId}`,
    BY_COURSE: (courseId) => `/student/certificates/course/${courseId}`,
    DOWNLOAD: (certificateId) => `/student/certificates/${certificateId}/download`,
    DETAILS: (certificateId) => `/student/certificates/${certificateId}/details`,
  },
    BULK_CREATE: "/students/bulk-create",
    PROFILE: "/student/profile",
    UPDATE_DOB: "/student/profile/dob",
    
    COURSES: {
      NOTIFICATIONS: (courseId) => `/student/courses/notifications/${courseId}`,
      AVAILABLE_COURSES: "/student/courses/available_courses",
      ENROLL: "/student/courses/enroll",
      ENROLLED_COURSES: "/student/courses/enrolled_courses",
      UNENROLL: `/student/courses/unenroll`,
      CONTENTS: (courseId) => `/student/courses/${courseId}/contents`,
      CONTENT_STATS: (courseId) =>
        `/student/courses/${courseId}/contents/stats`,
      NEXT_CONTENT: (courseId) => `/student/courses/${courseId}/contents/next`,
    },
    CONTENTS: {
      GET_BY_ID: (contentId) => `/student/contents/${contentId}`,
      UPDATE_PROGRESS: (contentId) => `/student/contents/${contentId}/progress`,
      MARK_COMPLETE: (contentId) => `/student/contents/${contentId}/complete`,
    },
 EXAMS: {
    BASE: "/exams",
    AVAILABLE: "/exams/available",
    HISTORY: "/exams/history",
    START: (examId) => `/exams/${examId}/start`,
    SAVE_ANSWER: (attemptId) => `/exams/attempt/${attemptId}/answer`,
    SUBMIT: (attemptId) => `/exams/attempt/${attemptId}/submit`,
    RESULTS: (attemptId) => `/exams/attempt/${attemptId}/results`,
    RESULTS_STATUS: (examId) => `/exams/${examId}/results-status`,
  },
  STUDENT_COURSE_NOTIFICATIONS: '/student/courses/notifications',
  },



  // College endpoints (Public access)
  COLLEGES: {
    DASHBOARD: "/college/dashboard",

    // Student Management
    STUDENTS: "/college/students",
    STUDENT_BY_ID: (id) => `/college/students/${id}`,
    STUDENTS_BULK_UPLOAD: "/college/students/bulk-upload",
    STUDENTS_TEMPLATE: "/college/students/upload-template",
    STUDENTS_PROGRESS: "/college/students/progress",
    STUDENTS_RETRY_SMS: "/college/students/retry-sms",
    STUDENTS_BULK_ENROLL: "/college/students/bulk-upload",
    STUDENTS_EXPORT: "/college/students/export",
    STUDENTS_IMPORT: "/college/students/import",
    STUDENTS_REPORT: "/college/students/report",
    STUDENTS_BY_COURSE: (courseId) => `/college/students/course/${courseId}`,
    STUDENT_ENROLLMENT_STATS: "/college/courses/students-distribution",
    STUDENT_ENROLLMENTS: (studentId) =>
      `/college/students/${studentId}/enrollments`,

    // Course Management (if applicable)
    ALL_COURSES: "/college/courses/all",
    PURCHASED_COURSES: "/college/courses",
    COURSE_BY_ID: (id) => `/colleges/courses/${id}`,
    OFFERED_DEGREES: (collegeId) => `/college/degrees-offered/${collegeId}`,

    // College Profile Management
    PROFILE: "/colleges/profile",
    UPDATE_PROFILE: "/colleges/profile",

    // Statistics and Reports
    STATISTICS: "/colleges/statistics",
    REPORTS: "/colleges/reports",

    // Notifications
    NOTIFICATIONS: "/colleges/notifications",

    // Settings
    SETTINGS: "/colleges/settings",
  },

  // SME endpoints
  SME: {
    BASE: "/sme",
    COURSES: "/sme/courses",
    CONTENT: "/sme/content",
    COURSE_CONTENTS: "/sme/courses/:courseId/contents",
    GET_CONTENT: "/sme/contents/:contentId",
    UPDATE_CONTENT: "/sme/contents/:contentId",
    DELETE_CONTENT: "/sme/contents/:contentId",
    CONTENT_STATISTICS: "/sme/contents/statistics",

    // File Upload
    UPLOAD_CONTENT: "/sme/courses/:courseId/upload",
    ASSESSMENTS: "/sme/assessments",
    COLLEGEBYCOURSE: (courseId) => `/sme/collegesByCourse/${courseId}`,
    NOTIFICATIONS: {
      BASE: "/sme/notifications",
      BY_ID: (id) => `/sme/notifications/${id}`,
      SEND: "/sme/send-notification",
      DELETE: (id) => `/sme/notifications/${id}`,
    },
  },

  // Admin endpoints
  ADMIN: {
    DASHBOARD: "/admin/dashboard",
    STATISTICS: "/admin/statistics",

    // College Management (Admin only)
    CREATE_COLLEGE: "/admin/college",
    COLLEGES: "/admin/colleges",
    COLLEGE_BY_ID: (id) => `/admin/college/${id}`,
    COLLEGE_APPROVE: (id) => `/admin/college/${id}/approve`,
    COLLEGE_SUSPEND: (id) => `/admin/college/${id}/suspend`,
    COLLEGES_SEARCH: "/admin/colleges/search",
    COLLEGES_STATISTICS: "/admin/colleges/statistics",
    COLLEGES_BULK_APPROVE: "/admin/bulk/colleges/approve",
    TOGGLE_COLLEGE_SUBSCRIPTION: "/admin/college/toggle-college-subscription",
    CONTENT_PENDING_APPROVALS: "/admin/contents/pending-approvals",
    CONTENT_APPROVE: (contentId) => `/admin/contents/${contentId}/approve`,
    CONTENT_REJECT: (contentId) => `/admin/contents/${contentId}/reject`,

    // User Management
    USERS: "/admin/users",
    USER_BY_ID: (id) => `/admin/user/${id}`,
    USER_STATUS: (id) => `/admin/user/${id}/status`,

    // SME Management
    SMES: "/admin/smes",
    CREATE_SME: "/admin/sme", // or '/admin/smes' depending on your route
    SME_BY_ID: (id) => `/admin/sme/${id}`,
    SME_ACTIVATE: (id) => `/admin/smes/${id}/activate`,
    SME_DEACTIVATE: (id) => `/admin/smes/${id}/deactivate`,
    SME_AVAILABILITY: (id) => `/admin/smes/${id}/availability`,
    SME_SEARCH: "/admin/smes/search",
    SME_BY_SUBJECT: (subject) => `/admin/smes/subject/${subject}`,
    SME_BY_SUBJECTS: "/admin/smes/subjects",
    SME_STATISTICS: "/admin/smes/statistics",

    // Course Categories
    COURSE_CATEGORIES: {
      CREATE: "/admin/course-categories/create",
      LIST: "/admin/course-categories/list",
      GET: "/admin/course-categories/get",
      UPDATE: "/admin/course-categories/update",
      DELETE: "/admin/course-categories/delete",
    },

    // Courses
    COURSES: {
      CREATE: "/admin/courses",
      LIST: "/admin/courses",
      GET: "/admin/courses/get",
      UPDATE: "/admin/courses/update",
      DELETE: "/admin/courses/delete",
      ASSIGN_SME: "/admin/courses/assign-sme",
      UNASSIGN_SME: (courseId, smeId) =>
        `/admin/courses/${courseId}/smes/${smeId}`,
      GET_SMES: "/admin/course/smes",
      COURSES_BY_ID: (id) => `/admin/courses/${id}`,
      COURSE_CONTENTS: (courseId) => `/admin/courses/${courseId}/contents`,
      COURSE_CONTENT_BY_ID: (contentId) => `/admin/contents/${contentId}`,
      COURSE_CONTENTS_REORDER: (courseId) =>
        `/admin/courses/${courseId}/contents/reorder`,
      COURSE_CONTENTS_STATISTICS: (courseId) =>
        `/admin/courses/${courseId}/contents/statistics`,
    },
    // Student Management
    STUDENTS: "/admin/students",
    STUDENTS_BULK_UPLOAD: "/admin/students/bulk-upload",
    STUDENTS_BULK_UPLOAD_JOB: (jobId) => `/admin/students/bulk-upload/jobs/${jobId}`,
    STUDENTS_PROGRESS: "/admin/students/progress",
 EXAMS: {
    BASE: "/admin/exams",
    BY_ID: (id) => `/admin/exams/${id}`,
    CREATE: "/admin/exams",
    UPDATE: (id) => `/admin/exams/${id}`,
    DELETE: (id) => `/admin/exams/${id}`,
    TOGGLE_STATUS: (id) => `/admin/exams/${id}/status`,
    DECLARE_RESULTS: (id) => `/admin/exams/${id}/results`,
    ATTEMPTS: (id) => `/admin/exams/${id}/attempts`,
    ANALYTICS: (id) => `/admin/exams/${id}/analytics`,
    QUESTIONS: (id) => `/admin/exams/${id}/questions`,
  },

    // Question Bank
    QUESTION_BANK: {
      BASE: "/question-bank",
      BY_ID: (id) => `/question-bank/${id}`,
      BULK_CREATE: "/question-bank/bulk",
      BULK_DELETE: "/question-bank/bulk",
      BY_COURSE: (courseId) => `/question-bank/course/${courseId}`,
    },

    // Bulk Operations
    BULK_USERS: "/admin/bulk/users",

    // Analytics

    CERTIFICATES: "/admin/certificates",
    CERTIFICATE_COLLEGES: "/admin/certificates/colleges",
    CERTIFICATE_STUDENTS: "/admin/certificates/students",
    CERTIFICATE_STUDENT_BY_ID: (studentId) => `/admin/certificates/students/${studentId}`,
    CUSTOM_CERTIFICATES: {
      UPLOAD: '/admin/custom-certificates/upload',
      JOB_STATUS: (jobId) => `/admin/custom-certificates/jobs/${jobId}`,
      JOB_DOWNLOAD: (jobId) => `/admin/custom-certificates/jobs/${jobId}/download`,
      JOBS_LIST: '/admin/custom-certificates/jobs',
    },
      ANALYTICS: {
      BASE: '/admin/analytics',
      ACTIVE_USERS:'/admin/analytics/active-users',
      ENROLLMENTS: '/admin/analytics/enrollments',
      MONTHLY_GROWTH: '/admin/analytics/monthly-growth',
      TOP_COLLEGES: '/admin/analytics/top-colleges',
      POPULAR_COURSES: '/admin/analytics/popular-courses',
      SUBJECT_COMPLETION: '/admin/analytics/subject-completion',
      EXAMS: '/admin/analytics/exams',
      CERTIFICATES: '/admin/analytics/certificates',
    },
  },

  ADMIN_CONFIG: {
    BASICS: {
      SMES: "/admin/smes",
      COLLEGES: "/admin/colleges",
      COURSES: "/admin-config/courses",
      DEGREES: "/admin-config/degrees",
      DEGREESBYCOLLEGE: "/admin-config/getDegreesByCollege/:collegeId",
    },
    COLLEGE_COURSE_MAPPINGS: {
      GET_ALL: "/admin-config/college-course-mappings",
      CREATE: "/admin-config/college-course-mappings",
      UPDATE: "/admin-config/college-course-mappings/:mappingId",
      DELETE: "/admin-config/college-course-mappings/:mappingId",
    },
    SME_COURSE_MAPPINGS: {
      GET_ALL: "/admin-config/sme-course-mappings",
      CREATE: "/admin-config/sme-course-mappings",
      DELETE: "/admin-config/sme-course-mappings/:mappingId",
    },
    DEGREE_CONFIGURATIONS: {
      GET_ALL: "/admin-config/degree-configurations",
      CREATE: "/admin-config/degree-configurations",
      UPDATE: "/admin-config/degree-configurations/:degreeId",
      DELETE: "/admin-config/degree-configurations/:degreeId",
      CREATE_SEMESTER: "/admin-config/degree-configurations/semesters",
    },
    COLLEGE_DEGREE_MAPPINGS: {
      GET_ALL: "/admin-config/college-degree-mappings",
      CREATE: "/admin-config/college-degree-mappings",
      UPDATE: "/admin-config/college-degree-mappings/:mappingId",
      DELETE: "/admin-config/college-degree-mappings/:mappingId",
    },
    COURSE_CATEGORIES: {
      GET_ALL: "/admin-config/course-categories",
      CREATE: "/admin-config/course-categories",
    },
    COURSE_PREREQUISITES: {
      GET_ALL: "/admin-config/course-prerequisites",
      GET_BY_COURSE: "/admin-config/course-prerequisites/:courseId",
      CREATE: "/admin-config/course-prerequisites",
      DELETE: "/admin-config/course-prerequisites/:prerequisiteId",
    },
    SEMESTER_PROMOTION: {
      PROMOTE: "/admin-config/promote-semester",
      PREVIEW: "/admin-config/promote-semester/preview",
    },
  },

  // Assessment endpoints
  ASSESSMENTS: {
    BASE: "/assessments",
    BY_ID: (id) => `/assessments/${id}`,
    SUBMIT: (id) => `/assessments/${id}/submit`,
    RESULTS: (id) => `/assessments/${id}/results`,
    ATTEMPTS: (id) => `/assessments/${id}/attempts`,
  },

  // Exam endpoints
  EXAMS: {
    BASE: "/exams",
    BY_ID: (id) => `/exams/${id}`,
    START: (id) => `/exams/${id}/start`,
    SUBMIT: (id) => `/exams/${id}/submit`,
    RESULTS: (id) => `/exams/${id}/results`,
  },

  // File upload endpoints
  UPLOADS: {
    IMAGE: "/uploads/image",
    VIDEO: "/uploads/video",
    DOCUMENT: "/uploads/document",
    BULK: "/uploads/bulk",
  },

  // Notification endpoints
  NOTIFICATIONS: {
    BASE: "/notifications",
    BY_ID: (id) => `/notifications/${id}`,
    MARK_READ: (id) => `/notifications/${id}/read`,
    MARK_ALL_READ: "/notifications/mark-all-read",
  },

  // Public Certificate endpoints (no auth required)
  PUBLIC: {
    CERTIFICATE_DETAILS: (certificateId) => `/certificates/${certificateId}`,
  },

  // Contact us (public, no auth required)
  CONTACT: {
    SUBMIT: "/contact",
  },

  // Chatbot endpoints
  CHATBOT: {
    CHAT: "/chatbot/chat",
  },

  // Admin chatbot management endpoints
  ADMIN_CHATBOT: {
    SETTINGS: "/admin/chatbot/settings",
    USAGE_STATS: "/admin/chatbot/usage-stats",
  },
};

export default API_ENDPOINTS;
